/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { JsonCreateTenant } from './JsonCreateTenant';
const CreateTenantDataParser = /* #__PURE__ */ parsers.object([
    ['json', JsonCreateTenant],
    ['logoDefault', parsers.file, 'logo-default'],
    ['logoDark', parsers.file, 'logo-dark'],
]);
export class CreateTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateTenantDataParser.decode(input).map(res => new CreateTenantData(res));
    }
    static unsafeDecode(input) {
        return CreateTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateTenantDataParser.encode(data);
    }
    static schema() {
        return CreateTenantDataParser.schema();
    }
}
